function parseMoney(value) {
  if (!value) return 0;
  const normalized = value.replace(/[^0-9.,-]/g, "").replace(/,/g, "");
  return parseFloat(normalized) || 0;
}

function updatePercentOffBadge() {
  const quantityBreaks = document.querySelector("quantity-breaks");
  if (!quantityBreaks) return;

  const productInfo = quantityBreaks.closest("product-info");
  if (!productInfo) return;

  const badge = productInfo.querySelector(".price__percent-off-badge");
  if (!badge) return;

  const checkedInput = quantityBreaks.querySelector('[name="quantity"]:checked');
  if (!checkedInput) return;

  const label = checkedInput.nextElementSibling;
  const dynamicPrice = label?.querySelector(".quantity-break__right.dynamic-price");
  const regularPriceEl = dynamicPrice?.querySelector(".quantity-break__price");
  const comparePriceEl = dynamicPrice?.querySelector(".quantity-break__compare-price");

  if (!regularPriceEl || !comparePriceEl || comparePriceEl.classList.contains("hidden")) return;

  const regular = parseMoney(regularPriceEl.textContent);
  const compare = parseMoney(comparePriceEl.textContent);
  if (compare <= regular) return;

  const percent = Math.floor(((compare - regular) / compare) * 100);
  const template = badge.dataset.textTemplate || "[percentage] OFF";
  badge.textContent = template.replace("[percentage]", `${percent}%`);
}

function updatePriceFromQuantityBreaks() {
  const quantityBreaks = document.querySelector("quantity-breaks");
  if (!quantityBreaks) return;

  const checkedInput = quantityBreaks.querySelector('[name="quantity"]:checked');
  if (!checkedInput) return;

  const label = checkedInput.nextElementSibling;
  if (!label) return;

  const dynamicPrice = label.querySelector(".quantity-break__right.dynamic-price");
  if (!dynamicPrice) return;

  const regularPriceEl = dynamicPrice.querySelector('.quantity-break__price');
  const comparePriceEl = dynamicPrice.querySelector('.quantity-break__compare-price');
  if (!regularPriceEl || !comparePriceEl) return;

  const regularPrice = regularPriceEl.textContent.trim();
  const comparePrice = comparePriceEl.textContent.trim();

  const productInfo = quantityBreaks.closest("product-info");
  if (!productInfo) return;

  const priceItem = productInfo.querySelector(".price-item");
  if (!priceItem) return;

  priceItem.innerHTML = `
    <span class="sale-price">${regularPrice}</span>
    <span class="compare-at-price">${comparePrice}</span>
  `;

  updatePercentOffBadge();
}

document.addEventListener("DOMContentLoaded", () => {
  updatePriceFromQuantityBreaks();
  updatePercentOffBadge();

  document.addEventListener("change", (e) => {
    if (e.target.matches('[name="quantity"]')) {
      updatePriceFromQuantityBreaks();
      updatePercentOffBadge();
    }
  });
});